// Where a project stands. One list for the phone, the web app, the MCP and the day plan.
//   active     being worked
//   on_hold    paused (waiting on the client, weather, money) — still pickable for receipts and blocks,
//              but its tasks leave the day plan until it's active again
//   completed  finished
//   cancelled  the client called it off (Alex's job) — kept for the record, out of everything live
//   archived   put away
// Old docs: no status = active; `archived: true` (an early flag) = archived.

export const PROJECT_STATUSES = [
  { key: 'active', label: 'Active', icon: 'play-circle', color: '#10B981', live: true },
  { key: 'on_hold', label: 'On hold', icon: 'pause-circle', color: '#F59E0B', live: true },
  { key: 'completed', label: 'Completed', icon: 'check-circle', color: '#3B82F6', live: false },
  { key: 'cancelled', label: 'Cancelled', icon: 'x-circle', color: '#EF4444', live: false },
  { key: 'archived', label: 'Archived', icon: 'archive', color: '#8C8175', live: false },
];
const BY_KEY = new Map(PROJECT_STATUSES.map((s) => [s.key, s]));

/** The project's status key, normalised ('active' when missing or unknown). */
export function projectStatus(p) {
  if (!p) return 'active';
  if (p.archived === true && (!p.status || p.status === 'active')) return 'archived';
  return BY_KEY.has(p.status) ? p.status : 'active';
}
export const projectStatusInfo = (p) => BY_KEY.get(projectStatus(p));
/** Live = active or on hold: shows in pickers (receipts, time blocks, quick add) and the "Open" list. */
export const isProjectLive = (p) => BY_KEY.get(projectStatus(p)).live;
/** Its tasks belong in the day plan / More (active only). */
export const isProjectWorking = (p) => projectStatus(p) === 'active';

/** Ids of projects whose tasks stay out of the day plan (anything not active). */
export function idleProjectIds(projects) {
  return new Set((projects || []).filter((p) => p && !isProjectWorking(p)).map((p) => p.id));
}

/**
 * The patch that moves a project to `status`: stamps when it was completed / cancelled / archived,
 * clears the stamps of the states it leaves, and drops the old `archived` flag.
 */
export function projectStatusPatch(status, at = Date.now()) {
  if (!BY_KEY.has(status)) throw new Error(`unknown project status "${status}" (${PROJECT_STATUSES.map((s) => s.key).join(', ')})`);
  return {
    status,
    archived: status === 'archived',
    completedAt: status === 'completed' ? at : null,
    cancelledAt: status === 'cancelled' ? at : null,
    archivedAt: status === 'archived' ? at : null,
    updatedAt: at,
  };
}
